import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/blocks/Modal";
import { BackendServices } from "services";
import { HelpUsResult } from "services/helpUsService/models/helpUsTypes";
import { useCookieContext } from "contexts";

type HelpUsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const HelpUsModal = ({ isOpen, onClose }: HelpUsModalProps) => {
  const { t } = useTranslation("Shared");
  const [helpUsData, setHelpUsData] = useState<HelpUsResult[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchHelpUsData();
    }
  }, [isOpen]);

  const fetchHelpUsData = async () => {
    setLoading(true);
    try {
      const response = await BackendServices.helpUsService.GetAllHelpUs({
        pageIndex: 0,
        pageSize: 0,
      });

      if (!response.hasError && response.data?.result) {
        setHelpUsData(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching help data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (pdfLink: string, fileName: string) => {
    const link = document.createElement("a");
    link.href = pdfLink;
    link.download = fileName;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t("Help")} size="lg">
      <div className="help-us-modal">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
            <div className="custom-loader"></div>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>{t("Name")}</th>
                  <th className="text-center">{t("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {helpUsData.length > 0 ? (
                  helpUsData.map((item) => (
                    <tr key={item.id}>
                      <td>{item.helpUsDetail?.name || "-"}</td>
                      <td className="text-center">
                        {item.helpUsDetail?.pdfLink ? (
                          <i
                            className="icon-pdf-templates cursor-pointer text-danger fs-4"
                            onClick={() =>
                              handleDownload(
                                item.helpUsDetail.pdfLink,
                                item.helpUsDetail.name || "help-document.pdf"
                              )
                            }
                            title={t("Download")}
                          ></i>
                        ) : (
                          <span className="text-muted">-</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center text-muted">
                      {t("NoDataAvailable")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default HelpUsModal;
